import React from 'react'
import { Row, Skeleton } from '@fs/zion-ui'

export default function MergeActionButtonRowSkeleton(): JSX.Element {
  return (
    <Row wrap alignX="end" alignItemsY="middle">
      <Skeleton.Chip width={98} />
      <div growX />
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <Skeleton.Button minWidth={80} />
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <Skeleton.Button minWidth={120} />
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <Skeleton.Button minWidth={90} />
    </Row>
  )
}
